import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="min-h-[90vh] flex items-center justify-center px-6 py-20" style={{
    backgroundColor: 'var(--color-background)'
  }} data-id="element-42">
      <div className="max-w-3xl mx-auto text-center" data-id="element-43">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" style={{
        fontFamily: 'var(--font-heading)',
        color: 'var(--color-text)'
      }} data-id="element-44">
          The 48-Hour Screen Detox: Get Your Child Back Without the War of Wills
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.1
      }} className="text-xl md:text-2xl mb-10 opacity-80" style={{
        color: 'var(--color-text)'
      }} data-id="element-45">
          Reset your child's dopamine baseline, end the "iPad-rage" meltdowns,
          and reclaim a peaceful home in just one weekend.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.2
      }} className="mb-16" data-id="element-46">
          <a href="#offer" className="inline-block px-8 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-200 hover:scale-[1.02]" style={{
          backgroundColor: 'var(--color-accent)'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'var(--color-accent-hover)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'var(--color-accent)'} data-id="element-47">
            Get the Recovery Plan — $6.39
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.3
      }} className="max-w-2xl mx-auto text-left" style={{
        borderLeft: '3px solid var(--color-accent)',
        paddingLeft: '1.5rem'
      }} data-id="element-48">
          <p className="text-lg leading-relaxed" style={{
          color: 'var(--color-text)'
        }} data-id="element-49">
            It's 6:00 PM. You ask them to put the tablet away for dinner.
            Seconds later, the screaming starts. The glazed eyes, the frantic
            negotiation, the "I hate you" that cuts deep—it feels like the child
            you love has been replaced by a stranger who only cares about the
            next digital hit.
          </p>
          <p className="text-lg leading-relaxed mt-4" style={{
          color: 'var(--color-text)'
        }} data-id="element-50">
            You aren't a bad parent for giving them the screen. You're an
            exhausted parent in a world designed to addict your child's brain.
            But you know this cycle can't continue.
          </p>
        </motion.div>
      </div>
    </section>;
}